import { useState, useEffect } from 'react';
import { useT } from '@/i18n';
import { useLanguageStore } from '@/stores/languageStore';
import { buildLocalizedPath } from '@/i18n';
import {
  initAnalytics,
  CONSENT_STORAGE_KEY,
  CONSENT_ACCEPTED,
  CONSENT_DECLINED,
} from '@/instrument';

export function CookieConsent() {
  const t = useT();
  const { language } = useLanguageStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(CONSENT_STORAGE_KEY);
      if (!consent) {
        setVisible(true);
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  function handleAccept() {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, CONSENT_ACCEPTED);
    } catch {}
    initAnalytics();
    setVisible(false);
  }

  function handleDecline() {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, CONSENT_DECLINED);
    } catch {}
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 border-t border-[var(--y-border)] bg-[var(--y-surface-primary)]"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="max-w-5xl mx-auto px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-sm leading-relaxed flex-1 text-[var(--y-text-secondary)]">
          {t('common.cookie.message')}{' '}
          <a
            href={buildLocalizedPath(language, '/privacy')}
            className="underline underline-offset-2 text-[var(--y-accent)]"
          >
            {t('common.cookie.privacyLink')}
          </a>
        </p>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="rounded-lg px-4 py-2 text-sm font-medium border border-[var(--y-border)] text-[var(--y-text-secondary)] transition-colors"
          >
            {t('common.cookie.decline')}
          </button>
          <button
            onClick={handleAccept}
            className="rounded-lg px-4 py-2 text-sm font-medium border border-[var(--y-accent)] text-[var(--y-accent)] transition-colors"
          >
            {t('common.cookie.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
